import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "../Navbar";
import { PageBgProvider, usePageBg } from "./PageBgContext";

const Shell: React.FC = () => {
	const [isOpen, setIsOpen] = useState(false);
	const { pageBg } = usePageBg();

	// Match the aside's bg to the current page so the rounded-corner cutout on
	// the Navbar blends with the page rather than showing a white wedge.
	const asideStyle = pageBg && pageBg !== "white" ? { backgroundColor: pageBg } : undefined;
	const asideBgClass = pageBg === "white" || !pageBg ? "bg-white" : "";

	return (
		<div
			className="flex flex-col lg:flex-row min-h-screen"
			style={asideStyle}
		>
			<aside
				className={`w-full lg:fixed lg:left-0 lg:top-0 lg:w-[280px] lg:min-w-[280px] lg:max-w-[280px] flex-shrink-0 ${asideBgClass} ${
					isOpen ? "h-screen" : "h-auto lg:h-screen"
				}`}
				style={asideStyle}
			>
				<Navbar isOpen={isOpen} onToggle={() => setIsOpen(!isOpen)} />
			</aside>

			{/* Spacer to prevent content from going under fixed sidebar on desktop */}
			<div className="hidden lg:block lg:w-[280px] lg:min-w-[280px] lg:flex-shrink-0" />

			<Outlet />
		</div>
	);
};

/**
 * Persistent app chrome (sidebar + navbar) rendered once for all protected
 * routes via React Router's nested route + <Outlet/> pattern. Keeping the
 * Navbar mounted across navigations is what prevents the avatar from
 * flickering on every route change / completed request.
 */
export const AppShell: React.FC = () => (
	<PageBgProvider>
		<Shell />
	</PageBgProvider>
);
